import axios, { AxiosPromise } from 'axios';

export const loadVinculos = (): AxiosPromise<any> =>
  axios.get(`/api/vinculos-declaracoes-itbi`);
